// It is height of the application page title, it's hardcoded here for quick solution
// TODO: Remove it and find better solution if needed

const TABLE_HEADER_OFFSET = 76;

export default TABLE_HEADER_OFFSET;
